const headphoneData = [
  {
    id: 2,
    tag: "featured-product",
    images: [
      "/images/products/boat518-1.png",
      "/images/products/boat518-2.png",
      "/images/products/boat518-3.png",
      "/images/products/boat518-4.png",
    ],
    brand: "boAt",
    title: "boAt Rockerz 518",
    info: "On-Ear Wireless Headphones",
    category: "Headphones",
    company: "boat",
    type: "On Ear",
    connectivity: "Wireless",
    finalPrice: [1290,2000],
    originalPrice: [2999,3000],
    quantity: 1,
    ratings: 1321,
    rateCount: 5,
    color:["Red", "Black","White"],
    color_varient: "Red,Gray",
    battery_life: "20 hours",
    noise_cancellation: "No",
    colorVariants: "Red , Black",

    path: "/product-details/",
  },

  {
    id: 5,
    images: [
      "/images/products/boat410-1.png",
      "/images/products/boat410-2.png",
      "/images/products/boat410-3.png",
      "/images/products/boat410-4.png",
    ],
    brand: "boAt",
    title: "boAt Rockerz 410",
    info: "Bluetooth & Wired On-Ear Headphones",
    category: "Headphones",
    company: "boat",
    type: "On Ear",
    connectivity: "Bluetooth & Wired",
    finalPrice: [3290,4533],
    originalPrice: [4299,5355],
    quantity: 1,
    ratings: 1563,
    rateCount: 5,
    battery_life: "12 hours",
    noise_cancellation: "Yes",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },

  {
    id: 7,
    tag: "hero-product",
    tagline: "Give your favourite music a boost.",
    heroImage: "/images/products/sonyxb910n-1.png",
    images: [
      "/images/products/sonyxb910n-1.png",
      "/images/products/sonyxb910n-2.png",
      "/images/products/sonyxb910n-3.png",
      "/images/products/sonyxb910n-4.png",
    ],
    brand: "Sony",
    title: "Sony WH-XB910N",
    info: "Wireless Over-Ear Headphones",
    category: "Headphones",
    company: "sony",
    type: "Over Ear",
    connectivity: "Wireless",
    finalPrice: [4290,6000],
    originalPrice: [5999,7000],
    quantity: 1,
    ratings: 679,
    rateCount: 4,
    battery_life: "30 hours",
    noise_cancellation: "Yes",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },

  {
    id: 8,
    tag: "featured-product",
    images: [
      "/images/products/jbl760nc-1.png",
      "/images/products/jbl760nc-2.png",
      "/images/products/jbl760nc-3.png",
      "/images/products/jbl760nc-4.png",
    ],
    brand: "JBL",
    title: "JBL Tune 760NC",
    info: "Wireless Over-Ear NC Headphones",
    category: "Headphones",
    company: "jbl",
    type: "Over Ear",
    connectivity: "Wireless",
    finalPrice: [6290,7000],
    originalPrice: [6999,8000],
    quantity: 1,
    ratings: 755,
    rateCount: 4,
    battery_life: "35 hours",
    noise_cancellation: "Yes",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },

  {
    id: 15,
    images: [
      "/images/products/sonych710n-1.png",
      "/images/products/sonych710n-2.png",
      "/images/products/sonych710n-3.png",
      "/images/products/sonych710n-4.png",
    ],
    brand: "Sony",
    title: "Sony WH-CH710N",
    info: "Wireless Over-Ear NC Headphones",
    category: "Headphones",
    company: "sony",
    type: "Over Ear",
    connectivity: "Wireless",
    finalPrice: [6290,7000],
    originalPrice: [6999,8000],
    quantity: 1,
    ratings: 853,
    rateCount: 4,
    description:
      "Sony WH-CH710N headphones offer excellent noise cancellation, wireless freedom, and high-fidelity sound for an immersive listening experience.",
    releaseDate: "2019-09-20",
    warranty: "2 years",
    colorVariants: "Red , Black",

    color:["Red", "Black","White"],

    battery_life: "10 hours",
    waterproof: "Yes",
    path: "/product-details/",
  },
  {
    id: 16,
    images: [
      "/images/products/jbl500bt-1.png",
      "/images/products/jbl500bt-2.png",
      "/images/products/jbl500bt-3.png",
      "/images/products/jbl500bt-4.png",
    ],
    brand: "JBL",
    title: "JBL Tune 500BT",
    info: "On-Ear Wireless Headphones",
    category: "Headphones",
    company: "jbl",
    type: "On Ear",
    connectivity: "Wireless",
    finalPrice: [16290,8000],
    originalPrice: [18999,10000],
    quantity: 1,
    ratings: 364,
    rateCount: 4,
    description:
      "JBL Tune 500BT headphones provide powerful bass, wireless convenience, and up to 16 hours of battery life for non-stop listening.",
    releaseDate: "2020-06-01",
    warranty: "1 year",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    battery_life: "10 hours",
    waterproof: "Yes",
    path: "/product-details/",
  },
];

const earbudsData = [
  {
    id: 10,
    images: [
      "/images/products/jbl100-1.png",
      "/images/products/jbl100-2.png",
      "/images/products/jbl100-3.png",
      "/images/products/jbl100-4.png",
    ],
    brand: "JBL",
    title: "JBL Wave 100",
    info: "In-Ear Truly Wireless Earbuds",
    category: "Earbuds",
    company: "jbl",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [1990,5000],
    originalPrice: [6999,8000],
    quantity: 1,
    ratings: 801,
    rateCount: 4,
    battery_life: "20 hours",
    waterproof: "Yes",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },

  {
    id: 11,
    images: [
      "/images/products/sony1000xm4-1.png",
      "/images/products/sony1000xm4-2.png",
      "/images/products/sony1000xm4-3.png",
      "/images/products/sony1000xm4-4.png",
    ],
    brand: "Sony",
    title: "Sony WF-1000XM4",
    info: "Wireless In-Ear NC Headphones",
    category: "Earbuds",
    company: "sony",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [6290,7000],
    originalPrice: [6999,8000],
    quantity: 1,
    ratings: 382,
    rateCount: 3,
    battery_life: "24 hours",
    noise_cancellation: "Yes",
    colorVariants: "Red , Black",
    waterproof: "yes",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },

  {
    id: 14,
    tag: "featured-product",
    images: [
      "/images/products/boat203-1.png",
      "/images/products/boat203-2.png",
      "/images/products/boat203-3.png",
      "/images/products/boat203-4.png",
    ],
    brand: "boAt",
    title: "boAt Airdopes 203",
    info: "In-Ear Truly Wireless Earbuds",
    category: "Earbuds",
    company: "boat",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [3290,4000],
    originalPrice: [5999,5000],
    quantity: 1,
    ratings: 1340,
    rateCount: 5,
    description:
      "boAt Airdopes 203 offers a truly wireless experience with rich sound quality and long-lasting battery life, perfect for on-the-go listening.",
    releaseDate: "2020-11-15",
    warranty: "1 year",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    battery_life: "10 hours",
    waterproof: "Yes",

    path: "/product-details/",
  },
  {
    id: 17,
    images: [
      "/images/products/boat381-1.png",
      "/images/products/boat381-2.png",
      "/images/products/boat381-3.png",
      "/images/products/boat381-4.png",
    ],
    brand: "boAt",
    title: "boAt Airdopes 381",
    info: "In-Ear Wireless Earbuds",
    category: "Earbuds",
    company: "boat",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [1220,2000],
    originalPrice: [3999,5000],
    quantity: 1,
    ratings: 1011,
    rateCount: 5,
    description:
      "boAt Airdopes 381 offers superior sound quality, a secure fit, and IPX5 water resistance, making them ideal for workouts and outdoor activities.",
    releaseDate: "2021-02-15",
    warranty: "1 year",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    battery_life: "10 hours",
    waterproof: "Yes",

    path: "/product-details/",
  },
];

const earphoneData = [
  {
    id: 4,
    images: [
      "/images/products/boat110-1.png",
      "/images/products/boat110-2.png",
      "/images/products/boat110-3.png",
      "/images/products/boat110-4.png",
    ],
    brand: "boAt",
    title: "boAt BassHeads 110",
    info: "In-Ear Wired Earphones",
    category: "Earphones",
    company: "boat",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: [1299,3499],
    originalPrice: [2999,5999],
    quantity: 1,
    ratings: 556,
    rateCount: 4,
    color_varient: "Black,Gray",
    driver_size: "10mm",
    frequency_response: "20Hz-20KHz",
    colorVariants: "Red , Green",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },
  {
    id: 12,
    images: [
      "/images/products/boat228-1.png",
      "/images/products/boat228-2.png",
      "/images/products/boat228-3.png",
      "/images/products/boat228-4.png",
    ],
    brand: "boAt",
    title: "boAt BassHeads 228",
    info: "In-Ear Wired Earphones",
    category: "Earphones",
    company: "boat",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: [6290,7000],
    originalPrice: [6999,8000],
    quantity: 1,
    ratings: 944,
    rateCount: 4,
    color_varient: "Blue,Black",
    driver_size: "10mm",
    frequency_response: "20Hz-20KHz",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },
  {
    id: 13,
    tag: "featured-product",
    images: [
      "/images/products/jbl-endu-1.png",
      "/images/products/jbl-endu-2.png",
      "/images/products/jbl-endu-3.png",
      "/images/products/jbl-endu-4.png",
    ],
    brand: "JBL",
    title: "JBL Endurance Run Sports",
    info: "In-Ear Wired Earphones",
    category: "Earphones",
    company: "jbl",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: [925,2600],
    originalPrice: [1200,3000],
    quantity: 1,
    ratings: 1144,
    rateCount: 5,
    description:
      "The JBL Endurance Run Sports earphones are designed for a comfortable and secure fit. They deliver high-quality sound and have a sweatproof design.",
    releaseDate: "2021-04-10",
    warranty: "1 year",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },
  {
    id: 18,
    images: [
      "/images/products/sony-ex14ap-1.png",
      "/images/products/sony-ex14ap-2.png",
      "/images/products/sony-ex14ap-3.png",
      "/images/products/sony-ex14ap-4.png",
    ],
    brand: "Sony",
    title: "Sony MDR-EX14AP",
    info: "In-Ear Wired Earphones",
    category: "Earphones",
    company: "sony",
    type: "In Ear",
    connectivity: "Wired",
    finalPrice: [6290,7000],
    originalPrice: [6999,8000],
    quantity: 1,
    ratings: 530,
    rateCount: 4,
    description:
      "Sony MDR-EX14AP earphones deliver clear sound with comfortable earbud tips, and include an in-line mic for hands-free calls.",
    releaseDate: "2020-03-05",
    warranty: "1 year",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },
];

const neckbandData = [
  {
    id: 6,
    images: [
      "/images/products/jbl200bt-1.png",
      "/images/products/jbl200bt-2.png",
      "/images/products/jbl200bt-3.png",
      "/images/products/jbl200bt-4.png",
    ],
    brand: "JBL",
    title: "JBL Live 200BT",
    info: "In-Ear Wireless Neckbands",
    category: "Neckbands",
    company: "jbl",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [6290,7000],
    originalPrice: [6999,8000],
    quantity: 1,
    ratings: 836,
    rateCount: 4,
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    battery_life: "10 hours",
    waterproof: "Yes",
    path: "/product-details/",
  },
  {
    id: 9,
    tag: "featured-product",
    images: [
      "/images/products/boat255r-1.png",
      "/images/products/boat255r-2.png",
      "/images/products/boat255r-3.png",
      "/images/products/boat255r-4.png",
    ],
    brand: "boAt",
    title: "boAt Rockerz 255",
    info: "In-Ear Wireless Neckbands",
    category: "Neckbands",
    company: "boat",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [1290,1000],
    originalPrice: [1999,2990],
    quantity: 1,
    ratings: 1464,
    rateCount: 5,
    battery_life: "8 hours",
    waterproof: "No",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },
  {
    id: 19,
    images: [
      "/images/products/sonyxb400-1.png",
      "/images/products/sonyxb400-2.png",
      "/images/products/sonyxb400-3.png",
      "/images/products/sonyxb400-4.png",
    ],
    brand: "Sony",
    title: "Sony WI-XB400",
    info: "Wireless Extra Bass In-Ear Neckbands",
    category: "Neckbands",
    company: "sony",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [6290,7000],
    originalPrice: [6999,8000],
    quantity: 1,
    ratings: 474,
    rateCount: 4,
    description:
      "Sony WI-XB400 neckbands offer powerful bass, up to 15 hours of battery life, and a lightweight design for all-day comfort.",
    releaseDate: "2019-08-12",
    warranty: "1 year",
    battery_life: "35 hours",
    waterproof: "yes",
    colorVariants: "Red , Black",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },
];

// ========================mobile data=============================================

const mobileData = [
  {
    id: 20,
    images: [
      "/images/products/iphone-13.png",
      "/images/products/sonyxb400-2.png",
      "/images/products/sonyxb400-3.png",
      "/images/products/sonyxb400-4.png",
    ],
    brand: "IPhone",
    title: "IPhone 13 pro",
    info: "Wireless Extra Bass In-Ear Neckbands",
    category: "Mobile",
    company: "iphone",
    type: "In Ear",
    connectivity: "Smartphone",
    finalPrice: [169000, 174999],
    originalPrice: [174999, 179999],
    quantity: 1,
    ratings: 474,
    rateCount: 4,
    ram: ["12GB-256GB", "16GB-512GB"],
    internal: ["256GB", "512GB"],
    color_varient: "Red,Black",
    path: "/product-details/",
    color:["Red", "Black","White"],

  },
  {
    id: 21,
    images: [
      "/images/products/galaxy-s23-ultra.png",
      "/images/products/sonyxb400-2.png",
      "/images/products/sonyxb400-3.png",
      "/images/products/sonyxb400-4.png",
    ],
    brand: "SAMSUNG",
    title: "Galaxy S23 Ultra",
    info: "Wireless Extra Bass In-Ear Neckbands",
    category: "Mobile",
    company: "samsung",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [109999, 114999],
    originalPrice: [110999, 115999],
    quantity: 1,
    ratings: 474,
    rateCount: 4,
    ram: ["8GB-256GB", "12GB-512GB"],
    internal: ["256GB", "512GB"],
    color_varient: "Green,Black,Silver",
    path: "/product-details/",
    color:["Red", "Black","White"],

  },
  {
    id: 22,
    images: [
      "/images/products/xiaomi-11.png",
      "/images/products/sonyxb400-2.png",
      "/images/products/sonyxb400-3.png",
      "/images/products/sonyxb400-4.png",
    ],
    brand: "Xiaomi",
    title: "Xiaomi Mi 11 Ultra",
    info: "Wireless Extra Bass In-Ear Neckbands",
    category: "Mobile",
    company: "xiaomi",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [2690, 4990],
    originalPrice: [4990, 7990],
    quantity: 1,
    ratings: 474,
    rateCount: 4,
    ram: ["6GB-128GB", "8GB-256GB"],
    internal: ["128GB", "256GB"],
    color_varient: "Red,Black,Blue",
    path: "/product-details/",
    color:["Red", "Black","White"],

  },
  {
    id: 23,
    images: [
      "/images/products/motorola.png",
      "/images/products/sonyxb400-2.png",
      "/images/products/sonyxb400-3.png",
      "/images/products/sonyxb400-4.png",
    ],
    brand: "Sony",
    title: "Sony WI-XB400",
    info: "Wireless Extra Bass In-Ear Neckbands",
    category: "Mobile",
    company: "sony",
    type: "In Ear",
    connectivity: "Wireless",
    finalPrice: [2990, 49590],
    originalPrice: [5990, 43990],
    quantity: 1,
    ratings: 474,
    rateCount: 4,
    ram: ["8GB-256GB", "12GB-512GB"],
    internal: ["256GB", "512GB"],
    color_varient: "Green,Black",
    path: "/product-details/",
    color:["Red", "Black","White"],

  },
  {
    id: 24,
    images: [
      "/images/products/mi-13-c.jpg",
      "/images/products/mi-13-c1.jpg",
      "/images/products/mi-13-c2.jpg",
      "/images/products/mi-13-c3.jpg",
    ],
    brand: "Xiaomi",
    title: "Redmi 13C",
    info: "Wireless Extra Bass In-Ear Neckbands",
    category: "Mobile",
    company: "xiaomi",
    type: "In Ear",
    connectivity: "Touch",
    finalPrice: [10999, 12999],
    originalPrice: [13990, 15990],
    quantity: 1,
    ratings: 474,
    rateCount: 4,
    ram: ["6GB-128GB", "8GB-256GB"],
    internal: ["128GB", "256GB"],
    color_varient: "Green,Red,Silver",
    color:["Red", "Black","White"],

    path: "/product-details/",
  },
];
const laptopData = [
  {
    id: 25,
    images: [
      "/images/products/ASUS.jpg",
      "/images/products/ASUS1.png",
      "/images/products/sonyxb400-3.png",
      "/images/products/sonyxb400-4.png",
    ],
    brand: "ASUS",
    title: "ASUS VivoBook 15",
    info: "Processor: Intel Celeron N4020, 1.1 GHz base speed, Up to 2.8 GHz Turbo Speed, 2 cores, 2 Threads, 4MB Cache; Memory & Storage: 4GB SO-DIMM DDR4 2400MHz RAM, Support up to 8GB using 1x SO-DIMM Slot with | Storage: 256GB M.2 NVMe PCIe SSD",
    category: "Laptop",
    company: "asus",
    type: "Laptop",
    connectivity: "Wireless",
    finalPrice: [62990,72000],
    originalPrice: [69999,84000],
        quantity: 1,
    ratings: 474,
    rateCount: 4,
    path: "/product-details/",
    description:
      "The ASUS VivoBook 15 is a compact laptop that immerses you in whatever you set out to do. It has a thin and light design, making it perfect for people who are always on the go.",
    releaseDate: "2021-05-15",
    warranty: "1 year",
    colorVariants: "Red , Black",
    processor: "Intel Celeron N4020",
    screenSize: "15.6 inches",
    ram: ["8GB-256GB", "12GB-512GB"],
    hdd: "256GB SSD",  
      color:["Red", "Black","White"],

  },
  {
    id: 26,
    images: [
      "/images/products/hplapi_1.jpg",
      "/images/products/hplapi_2.jpg",
      "/images/products/hplapi_3.jpg",
      "/images/products/hplapi_4.jpg",
    ],
    brand: "HP",
    title: "HP Laptop 15s",
    info: "HP Laptop 15s, 12th Gen Intel Core i5-1235U, 15.6-inch (39.6 cm), FHD, 16GB DDR4, 512GB SSD, Intel Iris Xe Graphics, Backlit KB, MSO, Thin & Light, Dual Speakers (Win 11, Silver, 1.69 kg), fq5330TU",
    category: "Laptop",
    company: "HP",
    type: "Laptop",
    connectivity: "Wireless",
    finalPrice: [32990,53000],
    originalPrice: [42999,64000],
        quantity: 1,
    ratings: 474,
    rateCount: 4,
    path: "/product-details/",
    description:
      "The HP Laptop 15s offers a balance of performance, productivity, and entertainment features with its 12th Gen Intel Core i5 processor and Intel Iris Xe Graphics, perfect for multitasking.",
    releaseDate: "2022-03-10",
    warranty: "1 year",
    colorVariants: "Red , Black",
    processor: "Intel Core i5-1235U",
    screenSize: "15.6 inches",
    ram: ["8GB-256GB", "12GB-512GB"],
    hdd: "512GB SSD",
    color:["Red", "Black","White"],

  },
  {
    id: 27,
    images: [
      "/images/products/acerlapi_1.jpg",
      "/images/products/acerlapi_2.jpg",
      "/images/products/acerlapi_3.jpg",
      "/images/products/acerlapi_4.jpg",
    ],
    brand: "Acer",
    title: "Acer Aspire Lite",
    info: "Acer Aspire Lite 12th Gen Intel Core i5-1235U Thin and Light Metal Laptop (Windows 11 Home/16GB RAM/512GB SSD/Intel Iris Xe Graphics/MSO) AL15-52, 39.62cm (15.6) Full HD Display, Steel Gray, 1.59 KG",
    category: "Laptop",
    company: "Acer",
    type: "Laptop",
    connectivity: "Wireless",
    finalPrice: [60990,75000],
    originalPrice: [79999,84000],    
    quantity: 1,
    ratings: 474,
    rateCount: 4,
    path: "/product-details/",
    description:
      "The Acer Aspire Lite is a sleek, lightweight laptop with powerful performance, featuring a 12th Gen Intel Core i5 processor, 16GB RAM, and a 512GB SSD for fast, efficient multitasking.",
    releaseDate: "2022-01-05",
    warranty: "1 year",
    colorVariants: "Red , Black",
    processor: "Intel Core i5-1235U",
    screenSize: "15.6 inches",
    ram: ["8GB-256GB", "12GB-512GB"],
    hdd: "512GB SSD",
    color:["Red", "Black","White"],

  },
  {
    id: 28,
    images: [
      "/images/products/len_lapi_1.jpg",
      "/images/products/len_lapi_2.jpg",
      "/images/products/len_lapi_3.jpg",
      "/images/products/len_lapi_4.jpg",
    ],
    brand: "lenovo",
    title: "Lenovo IdeaPad",
    info: "Lenovo IdeaPad 3 Intel Core i5-1235U 12th Gen 15.6 (39.62cm) FHD IPS Anti-Glare (8GB/512GB SDD/Windows 11/Office 2021/Backlit/1Yr Warranty/3months Game Pass/Arctic Grey/1.63Kg), 82RK00EDIN",
    category: "Laptop",
    company: "Lenovo",
    type: "Laptop",
    connectivity: "Wireless",
    finalPrice: [90990,32000],
    originalPrice: [109999,54000],
        quantity: 1,
    ratings: 474,
    rateCount: 3,
    path: "/product-details/",
    description:
      "The Lenovo IdeaPad 3 is designed for long-lasting performance with the latest Intel Core i5 processor, a 15.6-inch FHD display, and a backlit keyboard for a comfortable typing experience.",
    releaseDate: "2022-02-20",
    warranty: "1 year",
    colorVariants: "Red , Black",
    processor: "Intel Core i5-1235U",
    screenSize: "15.6 inches",
    ram: ["8GB-256GB", "12GB-512GB"],
    hdd: "512GB SSD",
    color:["Red", "Black","White"],

  },
  {
    id: 29,
    images: [
      "/images/products/dell_lapi_1.jpg",
      "/images/products/dell_lapi_2.jpg",
      "/images/products/dell_lapi_3.jpg",
      "/images/products/dell_lapi_4.jpg",
    ],
    brand: "Dell",
    title: "Dell 14 Laptop",
    info: "Dell 14 Laptop, 12th Gen Intel Core i5-1235U Processor, 16GB, 512GB, 14.0 (35.56cm) FHD Display, Windows 11 + MSO'21, Spill-Resistant Keyboard, 15 Month Mcafee, Black, Thin & Light- 1.48kg",
    category: "Laptop",
    company: "Dell",
    type: "Laptop",
    connectivity: "Wireless",
    finalPrice: [62990,72000],
    originalPrice: [69999,84000],
       quantity: 1,
    ratings: 474,
    rateCount: 5,
    path: "/product-details/",
    description:
      "The Dell 14 Laptop combines powerful performance with a sleek design, featuring a 12th Gen Intel Core i5 processor, 16GB RAM, and a 512GB SSD, ideal for both work and play.",
    releaseDate: "2022-04-10",
    warranty: "1 year",
    colorVariants: "Red , Black",
    processor: "Intel Core i5-1235U",
    screenSize: "14.0 inches",
    ram: ["8GB-256GB", "12GB-512GB"],
    hdd: "512GB SSD",
    color:["Red", "Black","White"],

  },
];

// tv==================
const tvData = [
  {
    id: 1,
    tag: "hero-product",
    tagline: "Brilliant, long lasting color with Quantum Dot",
    heroImage: "/images/products/samsung.png",
    images: [
      "/images/products/samsung.png",
      "/images/products/jbl660nc-2.png",
      "/images/products/jbl660nc-3.png",
      "/images/products/jbl660nc-4.png",
    ],
    brand: "SAMSUNG",
    title: "1.38 m QE1C QLED 4K Smart TV",
    info: "Brilliant, long lasting color with Quantum Dot",
    category: "TV",
    company: "samsung",
    type: "Over Ear",
    connectivity: "TV",
    finalPrice: [62990,72000],
    originalPrice: [69999,84000],
    quantity: 1,
    ratings: 1234,
    rateCount: 5,
    color_varient: "Black,Gray",
    picture_quality: "4K Ultra HD",
    screen_size: "55 inches",
    smart_features: "Google Assistant, Alexa, Smart Hub",
    colorVariants: "Red , Gray",
    path: "/product-details/",
    color:["Red", "Black","White"],

  },
  {
    id: 30,
    images: [
      "/images/products/mi_tv_1.jpg",
      "/images/products/mi_tv_2.jpg",
      "/images/products/mi_tv_3.jpg",
      "/images/products/mi_tv_4.jpg",
    ],
    brand: "Xiaomi",
    title: "Xiaomi 108 cm (43 inches) X Series 4K Ultra HD Smart Google TV L43M8-A2IN (Black)",
    info: "4K Ultra HD Smart TV, 108 cm (43 inches), Google TV, Dolby Vision, Dolby Audio, PatchWall, 2GB RAM, 16GB Storage, Bluetooth Remote, Google Assistant, Built-in Chromecast, Wi-Fi Connectivity",
    category: "TV",
    company: "xiaomi",
    type: "Smart TV",
    screen_size: "108 cm (43 inches)",
    picture_quality: "4K Ultra HD",
    connectivity: "Wireless",
    finalPrice: [27999,72000],
    originalPrice: [42999,130000],
    quantity: 1,
    ratings: 474,
    rateCount: 5,
    colorVariants: "Red , Black",
    path: "/product-details/",
    color:["Red", "Black","White"],

  },
  {
    id: 31,
    images: [
      "/images/products/sony_tv_1.jpg",
      "/images/products/sony_tv_2.jpg",
      "/images/products/sony_tv_3.jpg",
      "/images/products/sony_tv_4.jpg",
    ],
    brand: "Sony",
    title: "Sony Bravia 164 cm (65 inches) 4K Ultra HD Smart LED Google TV KD-65X74L (Black)",
    info: "4K Ultra HD Smart TV, 164 cm (65 inches), Google TV, TRILUMINOS Display, X1 4K HDR Processor, Dolby Vision, Dolby Atmos, Built-in Chromecast, Google Assistant, Wi-Fi Connectivity",
    category: "TV",
    company: "sony",
    type: "Smart TV",
    screen_size: "164 cm (65 inches)",
    picture_quality: "4K Ultra HD",
    connectivity: "Wireless",
    finalPrice: [75999,90000],
    originalPrice: [89900,100000],
    quantity: 1,
    ratings: 474,
    rateCount: 5,
    colorVariants: "Red , Black",
    path: "/product-details/",
    color:["Red", "Black","White"],

  },
  {
    id: 32,
    images: [
      "/images/products/panaso_tv_1.jpg",
      "/images/products/panaso_tv_2.jpg",
      "/images/products/panaso_tv_3.jpg",
      "/images/products/panaso_tv_4.jpg",
    ],
    brand: "Panasonic",
    title: "Panasonic 108 cm (43 inches) 4K Ultra HD Smart LED Google TV TH-43MX660DX (Black)",
    info: "4K Ultra HD Smart TV, 108 cm (43 inches), Google TV, Hexa Chroma Drive, HDR10+, Dolby Vision, Dolby Atmos, My Home Screen 6.0, Built-in Google Assistant, Wi-Fi Connectivity",
    category: "TV",
    company: "panasonic",
    type: "Smart TV",
    screen_size: "108 cm (43 inches)",
    picture_quality: "4K Ultra HD",
    connectivity: "Wireless",
    finalPrice: [29999,36000],
    originalPrice: [42900,50000],
    quantity: 1,
    ratings: 474,
    rateCount: 5,
    colorVariants: "Red , Black",
    path: "/product-details/",
    color:["Red", "Black","White"],

  },
  {
    id: 33,
    images: [
      "/images/products/sams_tv_1.jpg",
      "/images/products/sams_tv_2.jpg",
      "/images/products/sams_tv_3.jpg",
      "/images/products/sams_tv_4.jpg",
    ],
    brand: "Samsung",
    title: "Samsung 80 cm (32 inches) HD Ready Smart LED TV UA32T4380AKXXL (Glossy Black)",
    info: "HD Ready Smart TV, 80 cm (32 inches), HDR, Ultra Clean View, PurColor, Screen Mirroring, SmartThings App Support, Live Cast, Wi-Fi Connectivity",
    category: "TV",
    company: "samsung",
    type: "Smart TV",
    screen_size: "80 cm (32 inches)",
    picture_quality: "HD Ready",
    connectivity: "Wireless",
    finalPrice: [14990,20000],
    originalPrice: [18900,25000],
    quantity: 1,
    ratings: 474,
    rateCount: 5,
    colorVariants: "Red , Black",
    path: "/product-details/",
    color:["Red", "Black","White"],

  },
];


export {
  headphoneData,
  tvData,
  neckbandData,
  mobileData,
  laptopData,
  earbudsData,
  earphoneData,
};
